import { render, staticRenderFns } from "./UserServicesModal.vue?vue&type=template&id=79b8ed53"
import script from "./UserServicesModal.vue?vue&type=script&lang=js"
export * from "./UserServicesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports